import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchFor',
    standalone: false
})
export class SearchForPipe implements PipeTransform {

  transform(items: any[], searchText: string | undefined): any[] {
    if (!items) return [];
    if (!searchText) return items;

    const search = searchText.toLowerCase();

    return items.filter(item => this.deepSearch(item, search));
  }

  deepSearch(value: any, searchText: string): boolean {
    if (typeof value === 'string') {
      return value.toLowerCase().includes(searchText);
    }
    if (typeof value === 'number') {
      return value.toString().includes(searchText);
    }
    if (value && typeof value === 'object') {
      // recursion time!
      return Object.values(value).some(childValue => this.deepSearch(childValue, searchText));
    }
    return false;
  }
}